import React from 'react'
import Container from 'presentation/hospital/components/Container'
import { SolicitationCreateSurgicalScheduleLayout } from 'presentation/hospital/layouts/Home/SchedulingSector/SolicitationCreateSurgicalSchedule'
import SurgicalSchedulingContextWrapper from 'presentation/hospital/layouts/Home/SchedulingSector/context'

export default function SolicitationCreateSurgicalSchedule() {
  return (
    <SurgicalSchedulingContextWrapper>
      <Container>
        <SolicitationCreateSurgicalScheduleLayout />
      </Container>
    </SurgicalSchedulingContextWrapper>
  )
}
